import { graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import GatsbyImage from "gatsby-image"
import React from "react"
import Layout from "../components/layout"

function AboutPage({ data }) {
  const { site, codingImg, profileImg, bgImg } = data
  return (
    <Layout>
      <BackgroundImage
        className="aboutContainer"
        fluid={bgImg.childImageSharp.fluid}
      >
        <div className="container">
          <div className="row p-2">
            <div className="col-12 mt-5 text-center">
              <h1 className="text-danger pt-4 display-3">About</h1>
            </div>
            <div className="col-md-5 card mx-2 mx-md-auto my-2 p-2">
              <GatsbyImage
                fixed={codingImg.childImageSharp.fixed}
                className="my-2 mx-auto"
              />
              <h4 className="text-danger">NStF Blogs</h4>
              <p>{site.siteMetadata.aboutNStFBlogs}</p>
            </div>
            <div className="col-md-5 card mx-2 mx-md-auto my-2 p-2">
              <GatsbyImage
                fixed={profileImg.childImageSharp.fixed}
                className="my-2 mx-auto"
              />
              <h4 className="text-danger">Behind the scenes</h4>
              <p>{site.siteMetadata.behindTheScenes}</p>
            </div>
          </div>
        </div>
      </BackgroundImage>
    </Layout>
  )
}

export default AboutPage

export const containerQuery = graphql`
  query {
    bgImg: file(relativePath: { eq: "bg/bg4.jpg" }) {
      id
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    codingImg: file(relativePath: { eq: "coding.png" }) {
      childImageSharp {
        fixed(height: 280) {
          ...GatsbyImageSharpFixed_tracedSVG
        }
      }
    }
    profileImg: file(relativePath: { eq: "profile.png" }) {
      childImageSharp {
        fixed(height: 280) {
          ...GatsbyImageSharpFixed_tracedSVG
        }
      }
    }
    site {
      siteMetadata {
        aboutNStFBlogs
        behindTheScenes
      }
    }
  }
`
